import React from 'react'
import {
  Box,
  Text,
  Modal,
  Heading,
  PrimaryButton,
  Flex,
} from '@moonpig/launchpad-components'
import AppleHideEmailIcon from './assets/AppleHideEmail.svg'
import { useAuthenticationLocaleText } from '../../text-localisation'

export type PrivateEmailModalProps = {
  isOpen: boolean
  callback: () => void
}

export const PrivateEmailModal: React.FC<PrivateEmailModalProps> = props => {
  const localiseText = useAuthenticationLocaleText()

  return (
    <Modal label={'Private email modal'} mobilePagePeek isOpen={props.isOpen}>
      <Flex
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        width="480px"
        gap={8}
      >
        <Box width={'70px'} pb={4}>
          <img
            width={'100%'}
            src={AppleHideEmailIcon}
            alt={localiseText('auth_wizard.private_email_modal.alt')}
          />
        </Box>
        <Flex marginBottom={6} px={4} gap={8} flexDirection="column">
          <Heading
            level={'h2'}
            typography={{
              xs: 'typeMobileDisplay04',
              md: 'typeDesktopDisplay05',
            }}
          >
            {localiseText('auth_wizard.private_email_modal.heading')}
          </Heading>
          <Text typography={'typeMobileBodyText'}>
            {localiseText('auth_wizard.private_email_modal.content')}
          </Text>
        </Flex>
        <PrimaryButton width={'100%'} onClick={props.callback}>
          {localiseText('auth_wizard.private_email_modal.button')}
        </PrimaryButton>
      </Flex>
    </Modal>
  )
}
